import React from "react";

export default function UpiIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 4.5C1.5 3.67157 2.17157 3 3 3H21C21.8284 3 22.5 3.67157 22.5 4.5L1.5 4.5Z" fill="currentColor"/>
      <path d="M12 16.5C13.6569 16.5 15 15.1569 15 13.5C15 11.8431 13.6569 10.5 12 10.5C10.3431 10.5 9 11.8431 9 13.5C9 15.1569 10.3431 16.5 12 16.5Z" fill="currentColor"/>
      <path d="M0 7.5C0 6.67157 0.671573 6 1.5 6H22.5C23.3284 6 24 6.67157 24 7.5V19.5C24 20.3284 23.3284 21 22.5 21H1.5C0.671573 21 0 20.3284 0 19.5V7.5ZM4.5 7.5C4.5 9.15685 3.15685 10.5 1.5 10.5V16.5C3.15685 16.5 4.5 17.8431 4.5 19.5H19.5C19.5 17.8431 20.8431 16.5 22.5 16.5V10.5C20.8431 10.5 19.5 9.15685 19.5 7.5H4.5Z" fill="currentColor"/>
    </svg>
  );
}
